<template>
  <v-flex xs12>
    <v-container fluid pa-0 px-0>
      <v-layout wrap :style="'margin: 10px;'">
        <v-flex xs12 v-if="title && !titleRight" class="panelTitle" :style="marginBottom ? 'margin-bottom: ' + marginBottom + ';' : ''">{{ title }}</v-flex>
        <v-flex xs6 v-if="title && titleRight" class="panelTitle" :style="marginBottom ? 'margin-bottom: ' + marginBottom + ';' : ''">{{ title }}</v-flex>
        <v-flex xs6 text-xs-right v-if="title && titleRight" class="panelTitle" :style="marginBottom ? 'margin-bottom: ' + marginBottom + ';' : ''">{{ titleRight }}</v-flex>
        <v-flex xs12>
          <v-container fluid pa-0 px-3>
            <v-layout wrap>
              <slot></slot>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
  </v-flex>
</template>

<script>
export default {
  name: 'PanelColumn',
  props: ['title', 'titleRight', 'marginBottom']
}
</script>

<style scoped>
  .panelTitle {
    font-weight: bold;
    font-size: 12pt;
    font-style: normal;
    color: #004d40;
    border-bottom: 1px solid #004d40;
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/PanelColumn.vue